import type { ReactNode } from 'react';

import { DialogContent } from '../../../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../../../components/Dialog/DialogHeader';
import { DialogContent as DialogContentRedesign } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { DialogHeader as DialogHeaderRedesign } from '../../../../../components/Dialog/DialogUiRedesign/DialogHeader';

import styles from './PocViewConstructor.module.scss';

export function PocViewConstructor(props: {
  newDesign?: boolean;
  title: ReactNode;
  content: ReactNode;
  onGoBack?: VoidFunction;
  onClose?: VoidFunction;
}) {
  if (props.newDesign) {
    return (
      <div className={styles.container}>
        <DialogHeaderRedesign
          title={props.title}
          titleClassName={styles.header}
          onClose={props.onClose}
          onGoBack={props.onGoBack}
        />
        <DialogContentRedesign>{props.content}</DialogContentRedesign>
      </div>
    );
  }

  return (
    <div className="poc_overrideable">
      <DialogHeader className={styles.header} title={props.title} onClose={props.onClose} onGoBack={props.onGoBack} />
      <DialogContent className={styles.content}>{props.content}</DialogContent>
    </div>
  );
}
